module.exports = __webpack_public_path__ + "static/img/A36.9ffa6d31.jpg";